import React from 'react';
import PropTypes from 'prop-types';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { StyledSelect } from 'site-modules/shared/components/styled-select/styled-select';
import { TabsPanel } from 'client/site-modules/shared/components/tabs-panel/tabs-panel';
import { VIEW_BY_OPTIONS } from 'client/site-modules/infographics/constants/best-selling-cars';

export function ViewSelector({ onViewChange, selectedView = null, selectProps = {} }) {
  return (
    <div className="view-selector">
      <div className="d-flex mb-0_5">
        <span className="d-inline-block fw-bold me-0_5">By:</span>
        <TabsPanel
          options={VIEW_BY_OPTIONS}
          onTabClick={onViewChange}
          selectedOption={selectedView}
          className="d-inline-block"
          tabClassName="pt-0 pb-0_5 px-0 me-1"
        />
      </div>
      <Row>
        <Col xs={12} lg={4}>
          <StyledSelect {...selectProps} className="text-gray-darker" />
        </Col>
      </Row>
    </div>
  );
}

ViewSelector.propTypes = {
  onViewChange: PropTypes.func.isRequired,
  selectedView: PropTypes.string,
  selectProps: PropTypes.shape({}),
};
